export default {
  header: {
    title: 'Acheter une carte cadeau',
  },
  items: {
    gift_card: {
      label: 'Carte cadeau',
      title: 'Sélectionnez le montant souhaité',
      description: 'Ajoutez la carte cadeau avec la quantité souhaitée au panier',
    },
    expiration: {
      label: 'Valable 3 ans',
      title: 'Faites plaisir !',
      description: 'Le destinataire peut utiliser le bon librement pendant 3 ans.',
    },
    delivery: {
      label: 'Livraison immédiate en PDF par e-mail',
      title: 'Livraison instantanée en PDF par e-mail',
      description: 'Après paiement sécurisé par carte bancaire, PayPal ou giropay, vous recevrez le bon immédiatement.',
    },
  },
  form: {
    value: {
      title: 'Choisissez le montant de la carte cadeau',
      custom: {
        label: 'Personnalisé',
        placeholder: 'Saisir le montant',
      },
    },
    quantity: {
      title: 'Quantité',
    },
    email: {
      title: 'Quelle est votre adresse e-mail pour recevoir la carte cadeau ?',
      placeholder: 'Votre adresse e-mail',
    },
  },
  confirmation: {
    title: {
      title: 'Créer une carte cadeau ?',
      subtitle_one: 'Souhaitez-vous créer 1 carte cadeau pour {{value}} ?',
      subtitle_other: 'Souhaitez-vous créer {{count}} cartes cadeau pour {{value}} ?',
    },
    description: {
      total: 'Total :',
      email: 'E-Mail :',
      quantity: 'Quantité',
      amount: 'Montant',
    },
    footer: {
      cancel: 'Annuler',
      confirm: 'Confirmer',
    },
  },
  buttons: {
    create: 'Créer',
  },
  toasts: {
    error: 'La création de la carte cadeau a échoué.',
    success: 'Carte cadeau créée avec succès.',
  },
};
